import {randomId} from '../../../helpers';
import Multiselect from "../../../components/multiselect/src/Multiselect";

export default {
    components: {
        Multiselect,
    },
    data() {
        return {
            directors: {},
            preTitles,
            postTitles,
            localPreTitles: preTitles,
            localPostTitles: postTitles,
            tempPreTitle:[],
            tempPostTitle:[],
        };
    },
    computed: {
        directorIds() {
            return Object.keys(this.directors);
        },
        directorNames() {
            return _.mapValues(this.directors, (director) => `${director.title_prefix || ''} ${director.first_name || ''} ${director.last_name || ''} ${director.title_postfix || ''}`.trim());
        },
        partnerDirectors() {
            const partnerDirectors = {};
            _.forEach(this.directors, (director, id) => {
                if (this.directorIsPartner(director.id)) {
                    partnerDirectors[id] = director;
                }
            });

            return partnerDirectors;
        },
        partnerDirectorIds() {
            return Object.keys(this.partnerDirectors);
        },
        partnerDirectorNames() {
            return _.mapValues(this.partnerDirectors, (director) => `${director.title_prefix || ''} ${director.first_name || ''} ${director.last_name || ''} ${director.title_postfix || ''}`.trim());
        },
        notSelectedPartnerNames() {
            const notSelectedPartners = {};

            _.forEach(this.partners, (partner, partnerId) => {
                if (!this.directorIds.includes(partnerId) && (partner.type === 'natural')) {
                    notSelectedPartners[partnerId] = this.partnerNames[partnerId];
                }
            });

            return notSelectedPartners;
        },
        directorsCount() {
            return this.directorIds.length;
        },
        canDeleteDirectors() {
            // return this.directorsCount > 1;
            return true;
        },
        directorCountExceeded() {
            return this.directorsCount >= 5;
        },
        canAddFromPartners() {
            return _.isEmpty(this.notSelectedPartnerNames);
        }
    },
    methods: {
        changeGenderSetTitles(director){
            if(director.tempPreTitle){
                this.setTitleFieldsFromMultiselect(director.tempPreTitle,'pre', director.gender, director.id);
            }
            if(director.tempPostTitle){
                this.setTitleFieldsFromMultiselect(director.tempPostTitle,'post', director.gender, director.id);
            }
        },
        searchPreTitleInput(searchQuery) {
            if (searchQuery.length) {
                searchQuery = searchQuery.toLowerCase();
                this.localPreTitles = _.filter(this.preTitles, title => {
                    let matchedKeywords = title.keyword.filter(key => key.toLowerCase().indexOf(searchQuery) >= 0);
                    return matchedKeywords.length;
                });
            } else {
                this.localPreTitles = this.preTitles;
            }
        },

        searchPostTitleInput(searchQuery) {
            if (searchQuery.length) {
                searchQuery = searchQuery.toLowerCase();
                this.localPostTitles = _.filter(this.postTitles, title => {
                    let matchedKeywords = title.keyword.filter(key => key.toLowerCase().indexOf(searchQuery) >= 0);
                    return matchedKeywords.length;
                });
            } else {
                this.localPostTitles = this.postTitles;
            }
        },
        setTitleFieldsFromMultiselect(directorTitles, suffix ,gender, id) {
            let arrInput = [];
            let arrShortTitle = [];
            let arrLongTitle = [];
            directorTitles.forEach(title => {
                arrInput.push(title.input);
                arrShortTitle.push(title.short);
                switch (gender) {
                    case 'male':
                        arrLongTitle.push(title.full_male);
                        break;
                    case 'female':
                        arrLongTitle.push(title.full_female);
                        break;
                    default:
                        arrLongTitle.push(title.full_other)
                }
            })
            if (suffix === 'post') {
                this.directors[id].post_title = arrInput.join(', ');
                this.directors[id].post_title_short = arrShortTitle.join(', ');
                this.directors[id].post_title_long = arrLongTitle.join(', ');

            } else {
                this.directors[id].pre_title = arrInput.join(', ');
                this.directors[id].pre_title_short = arrShortTitle.join(', ');
                this.directors[id].pre_title_long = arrLongTitle.join(', ');
            }
        },
        addDirector() {
            this.clearValidationErrors();
            const directorId = randomId();

            this.$set(this.directors, directorId, {
                id: directorId,
                gender: 'male',
                tempPreTitle: null,
                tempPostTitle: null,
                pre_title: null,
                pre_title_short:null,
                pre_title_long:null,
                post_title: null,
                post_title_short:null,
                post_title_long:null,
                auto_generate_titles:true,
                first_name: null,
                last_name: null,
                birthdate: null,
                street: null,
                street_nr: null,
                zip_code: null,
                city: null,
                country: 'AT',
            });

            this.checkForDirectorDependencies(directorId);
        },
        addDirectorFromPartner(partnerId) {
            this.clearValidationErrors();
            const partner = this.partners[partnerId];
            this.$set(this.directors, partnerId, {
                id: partnerId,
                gender: partner.gender,
                tempPreTitle: partner.tempPreTitle,
                tempPostTitle: partner.tempPostTitle,
                pre_title:partner.pre_title,
                pre_title_short:partner.pre_title_short,
                pre_title_long:partner.pre_title_long,
                post_title:partner.post_title,
                post_title_short:partner.post_title_short,
                post_title_long:partner.post_title_long,
                auto_generate_titles:partner.auto_generate_titles,
                first_name: partner.first_name,
                last_name: partner.last_name,
                birthdate: partner.birthdate,
                street: partner.street,
                street_nr: partner.street_nr,
                zip_code: partner.zip_code,
                city: partner.city,
                country: partner.country,
            });
            this.checkForDirectorDependencies(partnerId);
        },
        directorIsPartner(directorId) {
            return this.partnerIds.includes(directorId);
        },
        directorRemoveConfirm(directorId) {
            this.$refs.directorDeleteModal.open(() => {
                this.removeDirector(directorId);
            })
        },
        removeDirector(directorId) {
            this.$delete(this.directors, directorId);
            this.checkForDirectorDependencies(directorId);
        },
        checkForDirectorDependencies(directorId) {
            this.removeDirectorFromSigningRights(directorId);

            if (!this.signingRulesCount) {
                this.addSigningStep();
            }
        }
    }
};
